import { Box } from '@mui/material';
import React from 'react';
import { useTranslation } from 'next-i18next';

import Typography from 'src/components/ui/Typography';
import BackLink from 'src/components/ui/BackLink';
import { colours } from 'src/constants/colours';
import { routePathHome } from 'src/constants/router';

interface Props {
    currentStep: number;
}

const EstimateFlowHeader: React.FC<Props> = ({ currentStep }) => {
    const { t } = useTranslation(['create-ad', 'common']);
    return (
        <>
            <Box display="flex" justifyContent="space-between" pb="2.5rem">
                <BackLink href={routePathHome}>{t('common:backToHome')}</BackLink>
                <Box display="flex" alignItems="center" justifyContent="space-between">
                    <Typography paragraph>
                        <span
                            dangerouslySetInnerHTML={{
                                __html: t('create-ad:step', {
                                    current: currentStep,
                                    total: 7,
                                }),
                            }}
                        />
                    </Typography>
                </Box>
            </Box>
            <Typography
                variant="h1"
                textTransform="uppercase"
                fontSize="1.6rem"
                fontWeight={700}
                lineHeight="0.875rem"
                color={colours.primary.main}
                pb="1.5rem"
            >
                {t('create-ad:estimate')}
            </Typography>
        </>
    );
};

export default EstimateFlowHeader;
